<template>

    <v-card tile outlined flat class="d-flex align-center justify-center" style="height: 100%; width: 100%">

        {{ error ? 'Сервис временно недоступен.' : '' }}

    </v-card>
</template>

<script>
    export default {
        props: {
            error: String
        }
    }
</script>

<style>

</style>